/**
 * Iter 159 · LandingRedirect — respects workspace `default_landing` setting.
 * Falls back to the classic BulletinBoard when not set.
 */
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import BulletinBoard from "@/pages/app/BulletinBoard";

const LANDING_MAP = {
  "dashboard": null,        // = fall through to BulletinBoard
  "sales-cc": "/app/sales-cc",
  "revenue-flow": "/app/finance/revenue-flow",
  "projects": "/app/projects",
};

export default function LandingRedirect() {
  const { activeWorkspaceId } = useAuth();
  const [choice, setChoice] = useState(undefined); // undefined = loading

  useEffect(() => {
    if (!activeWorkspaceId) { setChoice(null); return; }
    api.get(`/workspaces/${activeWorkspaceId}/settings`)
      .then(({ data }) => setChoice(data?.settings?.default_landing || null))
      .catch(() => setChoice(null));
  }, [activeWorkspaceId]);

  if (choice === undefined) return null; // still loading
  const dest = LANDING_MAP[choice];
  if (dest) return <Navigate to={dest} replace />;
  return <BulletinBoard />;
}
